module.exports = __webpack_public_path__ + "static/media/gitHubIcon.f25d8a38.svg";